import React from 'react';
import {
  LayoutDashboard,
  Activity,
  Paintbrush,
  Sparkles,
  Menu,
} from 'lucide-react';
import { useSite } from '../../context/SiteContext';

interface MobileBottomNavProps {
  currentView: string;
  onNavigate: (view: string) => void;
  onOpenMenu: () => void;
}

export const MobileBottomNav: React.FC<MobileBottomNavProps> = ({
  currentView,
  onNavigate,
  onOpenMenu,
}) => {
  const { activeSite } = useSite();

  const navItems = [
    {
      id: 'dashboard',
      label: 'Panel',
      icon: LayoutDashboard,
      badge: null,
    },
    {
      id: 'site-status',
      label: 'Durum',
      icon: Activity,
      badge: null,
    },
    {
      id: 'editor',
      label: 'Editör',
      icon: Paintbrush,
      badge: null,
      highlight: true,
    },
    {
      id: 'ai-visibility',
      label: 'AI Görünürlük',
      icon: Sparkles,
      badge: 'YENİ',
    },
  ];

  return (
    <nav
      aria-label="Mobil Hızlı Gezinti Menüsü"
      className="lg:hidden fixed bottom-0 left-0 right-0 z-40 bg-slate-900/95 backdrop-blur-lg border-t border-slate-800 shadow-2xl select-none"
      style={{ paddingBottom: 'env(safe-area-inset-bottom, 0px)' }}
    >
      <div className="flex items-center justify-around h-16 px-2">
        {navItems.map((item) => {
          const Icon = item.icon;
          const isActive = currentView === item.id;

          return (
            <button
              key={item.id}
              onClick={() => onNavigate(item.id)}
              className={`flex-1 flex flex-col items-center justify-center py-1 relative transition-colors ${
                isActive ? 'text-blue-400' : 'text-slate-400 hover:text-slate-200'
              }`}
            >
              <div className="relative">
                {item.highlight && isActive ? (
                  <div className="w-8 h-8 rounded-xl bg-blue-600 text-white flex items-center justify-center shadow-md shadow-blue-500/30">
                    <Icon className="w-4 h-4" />
                  </div>
                ) : (
                  <Icon className="w-5 h-5" />
                )}

                {item.badge !== null && (
                  <span className="absolute -top-1 -right-2 min-w-[16px] h-4 px-1 rounded-full bg-cyan-500 text-slate-950 font-extrabold text-[9px] flex items-center justify-center shadow">
                    {item.badge}
                  </span>
                )}
              </div>

              {!item.highlight || !isActive ? (
                <span className={`text-[10px] mt-1 font-medium tracking-tight ${isActive ? 'font-bold text-blue-400' : ''}`}>
                  {item.label}
                </span>
              ) : null}

              {isActive && !item.highlight && (
                <div className="w-1 h-1 rounded-full bg-blue-400 absolute bottom-1" />
              )}
            </button>
          );
        })}

        {/* Hamburger / Full Menu trigger */}
        <button
          onClick={onOpenMenu}
          className="flex-1 flex flex-col items-center justify-center py-1 text-slate-400 hover:text-slate-200 transition-colors"
        >
          <Menu className="w-5 h-5" />
          <span className="text-[10px] mt-1 font-medium tracking-tight">Menü</span>
        </button>
      </div>
    </nav>
  );
};
